<template>
  <div
    class="recommend-card"
    :style="{ height: height, width: width }"
  >
    <router-link
      :to="{path:`${visitPath}`}"
      target="_blank"
    >
    <!-- :style="{ 'background-image': `url(${imageUrl}!/fw/800)`, height: imageHeight }" -->
      <div
        class="card-image"
        
        @click="cardClick"
      >
        <img class="real-image" :style="{height: imageHeight}" :src="processUrl(imageUrl)">
        <div
          class="tag"
          v-if="days"
        >
          <span class="point"></span>
          <span>{{days}}日游</span>
        </div>
        <div
          :style="{top: imageHeight=== '320px'? '260px': '200px'}"
          class="image-bottom-area"
          v-if="trName"
        >
          <span>{{trName}}</span>
        </div>
      </div>
    </router-link>
    <slot>
      <div class="recommend-content">插槽占位符</div>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    visitPath: {
      type: String
    },
    height: {
      type: String,
      default: "430px"
    },
    width: {
      type: String,
      default: "380px"
    },
    imageHeight: {
      type: String,
      default: "320px"
    },
    imageUrl: {
      type: String,
      default: "../"
    },
    days: {
      type: Number
    },
    trName: {
      type: String
    }
  },
  methods: {
    processUrl(src) {
      if (src.indexOf("upcdn") !== -1 || src.indexOf("upyun") !== -1) {
        return `${src}!/fw/800`;
      }
      if (src.indexOf("aliyuncs") !== -1) {
        return `${src}?x-oss-process=image/resize,m_mfit,w_800`;
      }
      return src;
    },
    cardClick() {
      this.$emit("click");
    }
  }
};
</script>
<style lang="less">
.recommend-card {
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 15px 0px #d2d6df;
  margin: 15px;
  position: relative;
  transition: all 0.3s;
  &:hover {
    box-shadow: 0px 0px 8px #ddd;
    transform: scale(1.01);
  }
  .card-image {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // padding: 20px;
    text-align: left;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    .real-image {
      width: 100%;
      position: absolute;
    }
    .tag {
      position: absolute;
      top: 10px;
      left: 10px;
      padding: 8px 16px;
      border-radius: 30px;
      background: rgba(22, 22, 22, 0.5);
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      display: inline-block;
      .point {
        display: inline-block;
        height: 6px;
        width: 6px;
        border-radius: 3px;
        background: #45ebcb;
        margin-right: 8px;
        margin-bottom: 2px;
      }
    }
    .image-bottom-area {
      width: 100%;
      height: 60px;
      position: relative;
      font-size: 16px;
      padding: 20px;
      font-weight: bold;
      color: #ffffff;
      background: linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
      span {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
